// extracted by mini-css-extract-plugin
export var errorsContainer = "_t1-1";
export var link = "_t1-0";